import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
// Gutwin Shared Library
import { LoginService } from 'gutwin-shared';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const navigationExtras: NavigationExtras = {
      queryParams: { 'redirect_url': state.url }
    };

    if (this.loginService.isLoggedIn()) {
      return true;
    }

    this.router.navigate(['login'], navigationExtras);
    return false;
  }

}
